// extracted by mini-css-extract-plugin
export default {"normal":"CountDown_normal__KqN2G","big":"CountDown_big__CeUO5"};